// Document Editor constants — single source of truth for timing values
// used across Document.js, EditableTextSection.js, and related utils.

// Editing
export const AUTOSAVE_INTERVAL_MS = 15000;       // auto-save check interval for text sections
export const DEBOUNCE_SAVE_MS = 1000;            // debounce delay for text section saves

// UI feedback
export const SAVE_STATUS_TIMEOUT_MS = 2000;      // "saved" chip display duration
export const COPY_FEEDBACK_MS = 2000;            // clipboard copied icon display duration

// Approval
export const APPROVAL_EDIT_BEHAVIORS = {
  AUTO_UNAPPROVE: 'auto-unapprove',
  WARNING: 'warning',
  LOCK: 'lock',
};

export const SECTION_TABS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};
